export const MEMBER_COMPANY_DIRECTORY_PAGE_SIZE = 10;
export const MEMBER_COMPANY_DIRECTORY_SEARCH_DEBOUNCE_MS = 500;
export const MEMBER_COMPANY_DIRECTORY_FREE_TEXT_SEARCH_DEBOUNCE_MS = 500;
